<script>
/* COMPOSANTS */
import GaView from '@components/v2/layout/GaView';
import GaListView from '@components/v2/layout/GaListView.vue';
import AkDatatablePagination from '@components/v2/general/AkDatatablePagination.vue';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import MailTemplateUpdate from '@views/mailtemplate/MailTemplateUpdate.vue';
import {Icon} from '@iconify/vue';

/* MIXINS */
import randomRef from '@mixins/randomRef';
import utilsMixin from '@mixins/utilsMixin';
import mailTemplateConst from '@mixins/const/mailTemplateConst';

/* SERVICES */
import mailTemplateService from '@services/mailTemplateService';
import loaderMixin from '@mixins/loaderMixin';
import messageMixin from '@mixins/messageMixin';

export default {
  components: {
    MailTemplateUpdate,
    Icon,
    AkButtonValidation,
    AkDatatablePagination,
    GaListView,
    GaView,
  },
  mixins: [randomRef, loaderMixin, messageMixin, utilsMixin, mailTemplateConst],
  head() {
    return {
      title: 'settings.mail_template',
    };
  },
  data() {
    return {
      list: [],
      filter: undefined,
      sidebarUpdateVisible: false,
      searchValue: undefined,
      item: {},
      loading: true,
      submitted: false,
      mailTemplateId: undefined,
      displayEditDialog: false,
    };
  },
  computed: {
    listFilter() {
      if (this.list) {
        return this.list.filter(
          (i) =>
            this.searchValue === undefined ||
            i.brevoName?.toLowerCase().includes(this.searchValue?.toLowerCase()) ||
            this.displayForMailTechnicalKeyConst(i?.technicalName)
              ?.toLowerCase()
              .includes(this.searchValue?.toLowerCase()),
        );
      }
      return [];
    },
    sidebarVisible() {
      return this.sidebarUpdateVisible;
    },
    sidebarTitle() {
      if (this.sidebarUpdateVisible) {
        return this.$t('mail_template.update');
      }
      return '';
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    hideSidebar() {
      this.sidebarUpdateVisible = false;
    },
    toggleUpdateSidebar() {
      this.sidebarUpdateVisible = !this.sidebarUpdateVisible;
      if (this.sidebarUpdateVisible === false) {
        this.refresh();
      }
    },
    refresh() {
      this.loading = true;
      mailTemplateService.list().then((data) => {
        this.list = data;
        this.loading = false;
      });
    },
    search(value) {
      this.searchValue = value;
    },
    openUpdateSidebar(item) {
      this.mailTemplateId = item.id;
      this.sidebarUpdateVisible = true;
    },
  },
};
</script>

<template>
  <GaView>
    <template #content>
      <GaListView searchable @search="search">
        <template #content>
          <AkDatatablePagination :loading="loading" :value="listFilter" :lazy="false">
            <template #empty>
              {{ $t('mail_template.empty') }}
            </template>
            <Column sortable :header="$t('mail_template.name')" field="brevoName" style="min-width: 300px" />
            <Column sortable :header="$t('mail_template.technical_name')" style="min-width: 300px">
              <template #body="{data}">
                {{ displayForMailTechnicalKeyConst(data.technicalName) }}
              </template>
            </Column>
            <!--- todo: ne pas afficher la clé technique, mais un label -->
            <Column
              :header="$t('mail_template.active')"
              sortable
              body-style="text-align:center"
              style="width: 45px"
              field="active"
              header-style=" width: 45px; text-align: center">
              <template #body="slotProps">
                <i v-if="slotProps.data.active" class="ga-icon ga-check_circle text-primary text-2xl" />
                <i v-else class="ga-icon ga-close_circle text-redGa text-2xl" />
              </template>
            </Column>

            <Column body-style="text-align: right; overflow: visible" style="width: 220px">
              <template #body="slotProps">
                <div class="flex justify-end gap-2">
                  <span @click="openUpdateSidebar(slotProps.data)">
                    <i class="ga-icon ga-edit text-2xl text-primary md:hover:cursor-pointer" />
                  </span>
                </div>
              </template>
            </Column>
          </AkDatatablePagination>
        </template>
      </GaListView>
    </template>
    <template #extra>
      <Sidebar :visible="sidebarVisible" block-scroll :baseZIndex="9998" position="right">
        <template #container>
          <div class="p-sidebar-header">
            <div class="p-sidebar-header-content">{{ sidebarTitle }}</div>
            <button autofocus="" type="button" class="p-sidebar-close p-sidebar-icon p-link" @click="hideSidebar">
              <span
                class="p-sidebar-close-icon ga-icon ga-close_circle text-4xl text-gray md:hover:text-primary md:hover:bg-transparent"></span>
            </button>
          </div>
          <div class="p-sidebar-content">
            <perfect-scrollbar class="h-full">
              <MailTemplateUpdate
                :mail-template-id="this.mailTemplateId"
                v-if="sidebarUpdateVisible"
                @create-done="toggleUpdateSidebar" />
            </perfect-scrollbar>
          </div>
        </template>
      </Sidebar>
    </template>
  </GaView>
</template>
